import {createUseStyles} from 'react-jss';
import MediaQueries from '../../v2/style-helper/MediaQueries';

export default createUseStyles({
  menuContent: {
    [MediaQueries.phone]: {
      display: 'none',
    },
    background: '#fff',
    border: 'solid 1px #ccc',
    borderRadius: 2,
    filter: 'drop-shadow(0 0 3px rgba(0, 0, 0, 0.3))',
    display: 'block',
    position: 'absolute',
    width: 150,
    zIndex: '1',
    right: 150,
    top: '210%',
    transform: 'translateY(-50%) translateX(100%)',
    margin: 0,
    listStyle: 'none',
  },
  meatballMenu: {
    border: 'none',
    background: 'transparent',
    borderRadius: props => props.displayMenuContent && 4,
    boxShadow: props => props.displayMenuContent && '0 4px 6px 0 rgba(0, 0, 0, 0.2), 0 0 4px 1px rgba(0, 0, 0, 0.1)',
    
    '&:focus, &:hover': {
      borderRadius: 4,
      boxShadow: '0 4px 6px 0 rgba(0, 0, 0, 0.2), 0 0 4px 1px rgba(0, 0, 0, 0.1)',
    },
  },
  meatballMenuSvg: {
    width: 39,
  },
});
